module.exports = __webpack_public_path__ + "media/partner_pc1.1961767b.webm";